import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/stores/auth.store";

export default function GuestRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  return isAuthenticated() ? <Navigate to="/inventory" replace /> : <Outlet />;
}
